const CARIBBEAN_COUNTRY_IDS = [
    107052, 107055, 107060, 107065, 107074, 107126, 107199, 107200, 107216, 5815032,
];
const ENGLAND_COUNTRY_IDS = [107037, 107091, 107240, 200852];
export const EDITORIAL_CATEGORY_MEMBER_COUNTRY_IDS = {
    1965619: [107079, 107090, 107109, 107113, 107165, 107172],
    4133104: CARIBBEAN_COUNTRY_IDS,
    1888773: CARIBBEAN_COUNTRY_IDS,
    5814474: CARIBBEAN_COUNTRY_IDS,
    3051136: ENGLAND_COUNTRY_IDS,
};
export const EDITORIAL_CATEGORY_IDS_FOR_ANY_COUNTRY = [4133102];
export function withEditorialCategories(countryIds) {
    const present = new Set(countryIds);
    const added = [];
    for (const [categoryId, memberIds] of Object.entries(EDITORIAL_CATEGORY_MEMBER_COUNTRY_IDS)) {
        const id = Number(categoryId);
        if (!present.has(id) && memberIds.some(memberId => present.has(memberId))) {
            added.push(id);
        }
    }
    if (countryIds.length > 0) {
        for (const id of EDITORIAL_CATEGORY_IDS_FOR_ANY_COUNTRY) {
            if (!present.has(id))
                added.push(id);
        }
    }
    return added.length === 0 ? countryIds : [...countryIds, ...added];
}
//# sourceMappingURL=editorial-categories.js.map